// features/course/courseService.js

import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

// Get all courses
const getCourses = async () => {
  const response = await axios.get(`${base_url}course/`);
  return response.data;
};

// Create a new course
const createCourse = async (course) => {
 
  const response = await axios.post(`${base_url}course/`, course, config);
  return response.data;
};

// Get a single course
const getCourse = async (id) => {
  const response = await axios.get(`${base_url}course/${id}`, config);
  return response.data;
};

// Update a course
const updateCourse = async (course) => {
  const response = await axios.put(
    `${base_url}course/${course.id}`,
    {
      title: course.courseData.title,
      description: course.courseData.description,
      category: course.courseData.category,
      lecturer: course.courseData.lecturer,
      duration: course.courseData.duration,
      price: course.courseData.price,
      language: course.courseData.language,
      skillLevel: course.courseData.skillLevel,
      certificate: course.courseData.certificate,
      numLectures: course.courseData.numLectures,
      images: course.courseData.images,
      isFeatured: course.courseData.isFeatured,
      aboutCourse: course.courseData.aboutCourse,
      whatYouWillEarn: course.courseData.whatYouWillEarn,
    },
    config
  );
  return response.data;
};

// Delete a course
const deleteCourse = async (id) => {
  const response = await axios.delete(`${base_url}course/${id}`, config);
  return response.data;
};

const courseService = {
  getCourses,
  createCourse,
  getCourse,
  updateCourse,
  deleteCourse,
};

export default courseService;
